import request from '@/utils/request'
import request_py from '@/utils/request_py'
var api = {}
api.list = function(params) {
  return request({
    url: '/query/getSysUserList',
    method: 'get',
    params: params
  })
}

api.create = function(data) {
  return request({
    url: '/sys_user',
    method: 'post',
    data
  })
}
api.update = function(data) {
  return request({
    url: '/sys_user',
    method: 'put',
    data
  })
}
api.del = function(id) {
  return request({
    url: '/sys_user',
    method: 'delete',
    params: { id: id }
  })
}
api.updatePwd = function(params) {
  return request({
    url: '/sys_user/updatePwd',
    method: 'put',
    data: params
  })
}

api.updatePwdReset = function(params) {
  return request({
    url: '/sys_user/updatePwdReset',
    method: 'put',
    data: params
  })
}

api.role_list = function(user_id) {
  return request({
    url: '/sys_user_role?user_id=' + user_id,
    method: 'get'
  })
}
api.dept_list = function(user_id) {
  return request({
    url: '/sys_user_dept?user_id=' + user_id,
    method: 'get'
  })
}

api.reset_pass = function(user_id) {
  return request_py({
    url: '/login_by_qrcode/reset_pass?user_id=' + user_id,
    method: 'post'
  })
}
api.unbinding = function(user_id) {
  return request_py({
    url: '/login_by_qrcode/unbinding?user_id=' + user_id,
    method: 'post'
  })
}

api.get_null_account = function (params) {
  return request_py({
    url: '/login_by_qrcode/get_null_account',
    method: 'get',
    params
  })
}
// 交接工作
api.get_work_handover = function (params) {
  return request_py({
    url: '/pc_ext/work_handover',
    method: 'post',
    params
  })
}
// 人员是否绑定
api.get_check_sys_user_binding = function (params) {
  return request_py({
    url: '/pc_ext/check_sys_user_binding',
    method: 'get',
    params
  })
}
// 设置乡镇协理员管辖村社区
api.append_village_charge = function (params,data) {
  return request_py({
    url: '/pc_ext/set_user_village_charge',
    method: 'post',
    params,
    data
  })
}
api.del_village_charge = function (params) {
  return request_py({
    url: '/pc_ext/del_user_village_charge',
    method: 'delete',
    params
  })
}

// 修改账号行政区划，不允许跳级修改
api.post_mod_user_division = function (params,data) {
  return request_py({
    url: '/pc_ext/mod_user_division',
    method: 'post',
    params,
    data
  })
}
export default api



// WEBPACK FOOTER //
// ./src/api/sys_user.js